import { FC } from 'react'
import { VideoReactionButton } from '@/molecules/VideoReactionButton'
import { useCollectiblesPlayer } from '@/organisms/CollectiblesPlayer/CollectiblesPlayerContext'

export const FavoriteASceneOverlay: FC = () => {
  const { isShowingReactionButton } = useCollectiblesPlayer()

  if (!isShowingReactionButton) return null

  return (
    <div className="pointer-events-none fixed inset-0">
      <div className="absolute bottom-24 right-4">
        <VideoReactionButton brightMode={false} className="pointer-events-auto" />
      </div>
    </div>
  )
}
